export default {"src":"/_next/static/media/logo-original2.3ed8ec2a.svg","height":512,"width":512};